import { useEffect, useState } from "react";
import { Tab, Nav } from "react-bootstrap";
import StakeTab from "./StakeTab";
import UnstakeTab from "./UnstakeTab";
import ClaimTab from "./ClaimTab";
import CreatorInfo from "../creater/CreaterInfo";

export default function TabsSection({
  tokenBalance,
  tokenSymbol,
  value,
  handleChange,
  setValue,
  totalStakedFormatted,
  rewardsFormatted,
  openModal,
  availableStakes = {},
  childPools,
  bondAmount,
  stakerReward,
  walletAddress,
  poolCount = 0,
  totalRewardClaimed,
  tokenDecimals = 18, // 👈 pass this if available
  isRootPoolActive,
}) {
  const handleTabSelect = () => setValue(0);

  // ✅ Extract raw values
  const {
    amountETH = "0",
    restakeAmountETH = "0",
    claimTime = 0, // raw UNIX timestamp
  } = availableStakes;

  // console.log(typeof restakeAmountETH, restakeAmountETH, "Restake Amounttt");
  // ✅ Local state for live countdown string
  const [claimCountdown, setClaimCountdown] = useState("00D:00H:00M");

  // ✅ Format seconds → 00D:00H:00M
  const formatTime = (seconds) => {
    if (seconds <= 0) return "00D:00H:00M";
    const days = Math.floor(seconds / (24 * 3600));
    const hours = Math.floor((seconds % (24 * 3600)) / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    return `${days.toString().padStart(2, "0")}D:${hours
      .toString()
      .padStart(2, "0")}H:${minutes.toString().padStart(2, "0")}M`;
  };

  // ✅ Effect to update every minute
  useEffect(() => {
    if (!claimTime) return;

    const updateCountdown = () => {
      const now = Math.floor(Date.now() / 1000);
      const diff = claimTime - now;
      setClaimCountdown(formatTime(diff));
    };

    updateCountdown(); // run immediately

    const interval = setInterval(updateCountdown, 60 * 1000); // update every minute
    return () => clearInterval(interval);
  }, [claimTime]);

  return (
    <div className="left_Side_data">
      <Tab.Container defaultActiveKey="stake" onSelect={handleTabSelect}>
        {/* ✅ Tab Navigation */}
        <Nav variant="pills" className="mb-3">
          <Nav.Item>
            <Nav.Link eventKey="stake">Stake</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="unstake">Unstake</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="claim">Claim</Nav.Link>
          </Nav.Item>
        </Nav>

        {/* ✅ Tab Content */}
        <Tab.Content>
          {/* --- Stake Tab --- */}
          <Tab.Pane eventKey="stake">
            <StakeTab
              tokenBalance={tokenBalance}
              tokenSymbol={tokenSymbol}
              tokenDecimals={tokenDecimals}
              value={value}
              handleChange={handleChange}
              totalStakedFormatted={totalStakedFormatted}
              rewardsFormatted={rewardsFormatted}
              openModal={openModal}
              setValue={setValue}
              isRootPoolActive={isRootPoolActive}
            />
          </Tab.Pane>

          {/* --- Unstake Tab --- */}
          <Tab.Pane eventKey="unstake">
            <UnstakeTab
              tokenSymbol={tokenSymbol}
              value={value}
              handleChange={handleChange}
              openModal={openModal}
              availableStakes={availableStakes}
              setValue={setValue}
              restakeAmountETH={restakeAmountETH}
              isRootPoolActive={isRootPoolActive}
            />
          </Tab.Pane>

          {/* --- Claim Tab --- */}
          <Tab.Pane eventKey="claim">
            <ClaimTab
              tokenSymbol={tokenSymbol}
              openModal={openModal}
              rewardsFormatted={rewardsFormatted}
              claimCountdown={claimCountdown}
              claimTime={claimTime}
              isRootPoolActive={isRootPoolActive}
            />
          </Tab.Pane>

          {/* ✅ My Staking Summary */}
          <div className="staking_flow">
            <h3>My Staking</h3>
            <div className="tab_twoo">
              <div className="inner_child">
                <p>Total Staked</p>
                <span>
                  {parseFloat(amountETH)?.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 6,
                  }) +
                    " " +
                    tokenSymbol}
                </span>
              </div>

              <div className="inner_child">
                <p>Claimable Rewards</p>
                <span>{rewardsFormatted + " " + tokenSymbol}</span>
              </div>
              <div className="inner_child">
                <p>Restaked Amount</p>
                <span>
                  {parseFloat(restakeAmountETH)?.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 6,
                  }) +
                    " " +
                    tokenSymbol}
                </span>
              </div>

              <div className="inner_child">
                <p>Total Reward Claimed</p>
                <span>
                  {parseFloat(totalRewardClaimed)?.toLocaleString(undefined, {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 6,
                  }) +
                    " " +
                    tokenSymbol}
                </span>
              </div>
            </div>
          </div>
        </Tab.Content>
      </Tab.Container>

      {/* ✅ Creator Info */}
      <CreatorInfo
        childPools={childPools}
        bondAmount={bondAmount}
        walletAddress={walletAddress}
        poolCount={poolCount}
      />
    </div>
  );
}
